export type MalwareScanStatus = 'pending' | 'clean' | 'blocked' | 'scan_timed_out' | string | null;

export interface MalwareScanFields {
  malware_scan_status?: MalwareScanStatus;
  available_for_serving?: boolean;
  malware_scan_result?: string | null;
}

export type AttachmentScanState = 'available' | 'scanning' | 'unavailable';

export const getAttachmentScanState = ({
  malware_scan_status: malwareScanStatus,
  available_for_serving: availableForServing
}: MalwareScanFields): AttachmentScanState => {
  if (malwareScanStatus === 'pending') return 'scanning';
  if (
    availableForServing === false ||
    malwareScanStatus === 'blocked' ||
    malwareScanStatus === 'quarantined'
  ) {
    return 'unavailable';
  }

  return 'available';
};

export const isAttachmentAvailable = (attachment: MalwareScanFields): boolean =>
  getAttachmentScanState(attachment) === 'available';

export const isAttachmentScanning = (attachment: MalwareScanFields): boolean =>
  getAttachmentScanState(attachment) === 'scanning';

export const hasPendingAttachmentScan = (attachments?: MalwareScanFields[]): boolean =>
  attachments?.some(isAttachmentScanning) ?? false;
